import { DataOptions } from "../../types/data.types";
import { Data } from "../Data";
import { SettingsEmployee, SettingsEmployeeData } from "./SettingsEmployee";

export interface GroupMemberCountApiResponse {
  totalEmployees: number;
  overlapEmployees: SettingsEmployeeData[];
}

export interface GroupMemberCountOptions extends Omit<DataOptions, "api" | "callback" | "method"> {
  resolve: (data: SettingsGroupMemberCount, cached: boolean) => void;
  postData: {
    jobDefinitionIds: string[];
    locationIds: string[];
    managerIds: (string | undefined)[];
  };
}

export class SettingsGroupMemberCount extends Data {
  managerMemberOverlap: SettingsEmployee[];
  totalEmployees: number;

  constructor(options: GroupMemberCountOptions) {
    super({
      api: "/Group/CountEmployeesByJobDefinitionsAndLocations",
      callback: () => {
        options.resolve(this, false);
      },
      method: "post",
      ...options
    });

    this.managerMemberOverlap = [];
    this.totalEmployees = 0;
  }

  onDataReceived(data: GroupMemberCountApiResponse): void {
    this.totalEmployees = data.totalEmployees;
    data.overlapEmployees.forEach((e: SettingsEmployeeData) =>
      this.managerMemberOverlap.push(new SettingsEmployee(e))
    );
  }
}
